import { Theme } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles((theme: Theme) => ({
  main: {
    display: "flex",
    flexDirection: "column",
    gap: "0.4rem",
  },
  label: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    color: colors.brandBlue600,
  },

  section: {
    display: "flex",
    gap: "1rem",
    flexWrap: "wrap",
  },

  divLogo: {
    borderRadius: " 12px",
    width: "180px",
    height: "80px",
    background: "#F8FAFC",
  },

  inputLogo: {
    display: "flex !important",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    flexDirection: "column",
    gap: "0.4rem",
    cursor: "pointer",

    "& img": {
      width: "100%",
      height: "100%",
      borderRadius: "12px",
    },

    "& > span": {
      fontFamily: "Manrope",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "150%",
    },

    "& input": {
      display: "none",
    },
  },

  imageContainer: {
    border: "1px solid #E4E7EC",
    borderRadius: "12px",
  },

  choosePictureButtonContainer: {
    display: "flex",
    marginTop: "12px",
    marginBottom: "8px",
    "& span": {
      fontFamily: "Inter  !important",
      fontWeight: "600 !important",
      fontSize: "12px !important",
    },
  },
  changePictureButton: {
    widht: "130px",
  },
  removeButton: {
    widht: "47px",
    marginLeft: "28px",
  },

  divRulesLogo: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",

    "& strong, & span": {
      fontFamily: "Manrope",
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "24px",
    },

    "& strong": {
      fontWeight: "600",
    },

    "& span": {
      fontWeight: "400",
    },
  },

  cropContainer: {
    position: "relative",
    width: "100%",
    height: 200,
    background: "#FFF",
    [theme.breakpoints.up("sm")]: {
      height: 400,
    },
  },
  onError: {
    border: "1px solid #f04438",
  },
}));

export default styles;
